import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject, Observable, Subscription, interval } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { Router } from '@angular/router';
import { SharedApiService } from '../../../pages/shared/api.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private subscription: Subscription;

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;
  userDetail: any;
  unreadCount: number = 0;
  notifications: any[] = [];
  showDropdown: boolean = false;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: 'Profile' },
    { title: 'Products' },
    { title: 'Help/Guide' },
    { title: 'Log out' }];

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private router: Router,
    private sharedApi: SharedApiService
  ) {

    this.userDetail = this.sharedApi.getData('userDetail');


    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));


    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title =>
        this.selectedMenuAction(`${title}`)
      );

  }

  ngOnInit() {
        setTimeout(() => {
      this.toggleSidebar();
    }, 1000);

    this.getNotification();

    // Call the function every 60 seconds (60000 ms)
    this.subscription = interval(60000).subscribe(() => {
      this.getNotification();
    });

    // Start SignalR connection
    //this.sharedApi.startSignalRConnection();

    // Listen to SignalR updates
    // this.sharedApi.hubConnection.on('ReceiveNotification', (data) => {
    //   console.log('New notification received:', data);
    //   this.notifications.unshift({ ...data, isNew: true });
    //   this.unreadCount++;
    //   this.sharedApi.unreadCountSubject.next(this.sharedApi.unreadCount); // notify
    // });

    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });

  }
  
 // Add method to handle bell click
  onBellClick() {
    this.sharedApi.notifyBellClicked();
  }

  openNotificationComponent(): void {
    this.showDropdown = false;
    this.router.navigate(['/pages/shared/notifications']);
    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getNotification(): void {
    console.log('Function called every 10 seconds');
    // Initial fetch
    this.sharedApi.getUnreadNotifications().subscribe((data: any[]) => {
      this.notifications = data;
      this.unreadCount = data.length;
      this.sharedApi.unreadCountSubject.next(this.unreadCount); // <-- sync on init
    });
    // Subscribe to unreadCount changes
    this.sharedApi.unreadCount$.subscribe(count => {
      this.unreadCount = count;
    });
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  selectedMenuAction(title) {
    if (title === 'Log out') {
      this.sharedApi.clearData();
      this.router.navigate(['/login']);
    }
    else if (title === 'Products') {
      this.router.navigate(['/pages/shared/productpage']);
    }
    else if (title === 'Help/Guide') {
      this.router.navigate(['/pages/shared/help-guide']);
    }
  }


}
